export default __webpack_public_path__ + "static/art-innovation--mobile-f2e23f6ead5ed14e509885ce2c7d0ba7.webp";